import { useQuery } from '@tanstack/react-query';
import { logoutApi } from '../api/logout.api';
import type { SessionRevocationSummary } from '../types/logout.types';

/**
 * Query: GET /api/eraf/auth/logout/sessions/{userId}
 * Only fetches when enabled=true (user has submitted a userId to look up).
 */
export function useActiveSessions(userId: number, enabled: boolean) {
  return useQuery<SessionRevocationSummary, { code: string; message: string }>({
    queryKey: ['logout', 'sessions', userId],
    queryFn: () => logoutApi.getActiveSessions(userId),
    enabled: enabled && userId > 0,
    retry: false,
    staleTime: 0,
  });
}
